module.exports = __webpack_public_path__ + "img/profile.4750b90e.svg";